import { render } from "./DataConsentTextContent.vue?vue&type=template&id=d6cff8a4&scoped=true"
const script = {}

import "./DataConsentTextContent.vue?vue&type=style&index=0&id=d6cff8a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6cff8a4"]])

export default __exports__